import React from 'react';
import { IconChevronDown } from './QuirkIcons';
import styles from './ShowMoreButton.module.css';
interface ShowMoreProps {
	label?: string;
	onClick?: () => void;
}

export const ShowMoreButton: React.FC<ShowMoreProps> = ({ label, onClick }) => (
	<div onClick={onClick} className={styles.showlabelContainer}>
		<div className={styles.showlabel}>{label || 'Show more'}</div>
		<div className={styles.iconContainer}>
			<IconChevronDown />
		</div>
	</div>
);
